module.exports = __webpack_public_path__ + "media/img/frontend_application/snap-43142f79f09d97f44f74bbca82352dd9.png";